<template>
  <div class="screener h-100">
    <div class="container h-100">
      <transition name="slide-left" mode="out-in">
        <router-view/>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Screener',
  created: function () {
    const routeParams = this.$route.params

    this.source = new URLSearchParams(window.location.search).get('source')

    if ((routeParams.group !== 'basics' || routeParams.question !== 'name') && this.$route.name !== 'email') {
      this.$router.push({
        name: 'questions',
        params: {
          group: 'basics',
          question: 'name'
        }
      })
    }

    this.$root.$on('email_entered', email => {
      this.email = email
    })
  },
  data () {
    return {
      email: '',
      source: ''
    }
  }
}
</script>

<style lang="less" scoped>
.screener {
  min-height: 100%;

  .container {
    max-width: 550px;
  }
}
</style>
